import { useCredits } from "components/Credits/useCredits";
import { Loading, Panel } from "components/panels";
import React from "react";

export const CreditDetails = () => {
  const credits = useCredits();

  return <Panel
    title="Credit balance"
    panelClassName="s1_related-feature-panel"
  >
    <div className="flex-column gap-larger">
      <div className="text-light">
        Your credit balance will be consumed with AI data import and Peppol usage. You can buy credits directly or set up auto-reload thresholds.
      </div>

      <div
        className="flex-column gap justify-center align-center"
        style={{
          width: "176px",
          height: "176px",
          borderRadius: "var(--radius-medium)",
          background: "var(--card-bg)"
        }}>
        <div className="huge_text" style={{ textAlign: "center", fontWeight: 700 }}>
          {credits ?? <Loading />}
        </div>
        <div style={{ textAlign: "center" }}>
          Available Credits
        </div>
      </div>
    </div>

  </Panel>
}